import type { Party } from "@paparazzi/types/paparazzi.api.serializers.parties";
import { createStore } from "@virgodev/vue-models/utils/create_store";

export interface PartyWithId extends Party {
  id: number;
  host_credits?: number;
  total?: number;
  orders?: {}[];
  total_guests?: number;
}

export const usePartyStore = createStore<PartyWithId>("parties", {
  endpoint: "parties/my",
  // responseKey: "results",
});
